module.exports = __webpack_public_path__ + "static/media/ic_review-letter.2a5875c1.svg";